import colors from 'styles/theme/colors';

export default function NoteIconOutline({
  width = 23,
  height = 26,
  color = colors.black100,
  ...rest
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width={width} height={height} fill='none' {...rest}>
      <path
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeMiterlimit='10'
        d='M13.8 25H1V1h20.8v16l-8 8Z'
      />
      <path
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeMiterlimit='10'
        d='M13.8 25v-8h8M5.8 7.4H17M5.8 12.2H17M5.8 17H9'
      />
    </svg>
  );
}
